import utf8 from "utf8";
import moment from "moment";
import { decode as atob } from "base-64";
import momentTimezone from "moment-timezone";

export const timeSlots = [
  "00:00",
  "00:30",
  "01:00",
  "01:30",
  "02:00",
  "02:30",
  "03:00",
  "03:30",
  "04:00",
  "04:30",
  "05:00",
  "05:30",
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
  "00:00",
];

export const DayWeeks = [
  {
    Sunday: "Sunday",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
  },
  {
    Sunday: "Domingo",
    Monday: "Segunda-feira",
    Tuesday: "Terça-feira",
    Wednesday: "Quarta-feira",
    Thursday: "Quinta-feira",
    Friday: "Sexta-feira",
    Saturday: "Sábado",
  },
  {
    Sunday: "Domingo",
    Monday: "Lunes",
    Tuesday: "Martes",
    Wednesday: "Miércoles",
    Thursday: "Jueves",
    Friday: "Viernes",
    Saturday: "Sábado",
  },
];

export const DateMonth = [
  {
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",
  },
  {
    January: "Janeiro",
    February: "Fevereiro",
    March: "Março",
    April: "Abril",
    May: "Maio",
    June: "Junho",
    July: "Julho",
    August: "Agosto",
    September: "Setembro",
    October: "Outubro",
    November: "Novembro",
    December: "Dezembro",
  },
  {
    January: "Enero",
    February: "Febrero",
    March: "Marzo",
    April: "Abril",
    May: "Mayo",
    June: "Junio",
    July: "Julio",
    August: "Agosto",
    September: "Septiembre",
    October: "Octubre",
    November: "Noviembre",
    December: "Deciembre",
  },
  {
    January: "Janvier",
    February: "Février",
    March: "Mars",
    April: "Avril",
    May: "Mai",
    June: "Juin",
    July: "Juillet",
    August: "Août",
    September: "Septembre",
    October: "Octobre",
    November: "Novembre",
    December: "Décembre",
  },
];

export function getScheduleConvertTimezoneFromUTC(dateUtc, hourUTC, timezone) {
  const utc = dateUtc + "T" + hourUTC + ".000Z";
  return moment(utc).tz(timezone);
}

export function getNowConvertConvertedTimeZone(timezone) {
  return moment(momentTimezone.utc().tz(timezone));
}

export function firstLastName(name = "") {
  let nameArray = name.trim().split(" ");
  return nameArray[0];
}

export const getLocalTimeFromUtc = (user) => {
  return moment.tz(moment(), user.timezone);
};

export function handleTranslateAsyncStorage(token) {
  const payload = token?.split(".")[1];
  const base64 = payload?.replace("-", "+").replace("_", "/");
  const resJson = JSON.parse(atob(base64));
  const name = utf8.decode(resJson.name);
  resJson.name = name;
  const tempData = resJson;

  return tempData;
}

export const timeConvert = (n) => {
  let num = n;
  let hours = num / 60;
  let rhours = Math.floor(hours);
  let minutes = (hours - rhours) * 60;
  let rminutes = Math.round(minutes);
  return rminutes == 0 ? `• (${rhours}h)` : `• (${rhours}h:${rminutes}m)`;
};

export function userTimezoneConvert(time, timeTimezone, user) {
  return momentTimezone.tz(time, timeTimezone).clone().tz(user.timezone);
}

export function userTimezoneConvert2(time, timeTimezone, destTimezone) {
  if (destTimezone && destTimezone === "America/Sao_Paulo") {
    destTimezone = "America/Bahia";
  }
  return momentTimezone.tz(time, timeTimezone).clone().tz(destTimezone);
}

export function handleTranslateDayWeek(language, dayweek) {
  return language === "US"
    ? DayWeeks[0][`${dayweek}`]
    : language === "BR"
    ? DayWeeks[1][`${dayweek}`]
    : DayWeeks[2][`${dayweek}`];
}

export const cap = (str) => str.replace(str[0], str[0].toUpperCase());

export const tagDays = [
  "WEEK_SUNDAY",
  "WEEK_MONDAY",
  "WEEK_TUESDAY",
  "WEEK_WEDNESDAY",
  "WEEK_THURSDAY",
  "WEEK_FRIDAY",
  "WEEK_SATURDAY",
];

export const getRequestReplacingEmptyStringsToNull = (req, obj) => {
  if (obj) {
    Object.keys(req).forEach((key) => {
      req[key] = obj[key] === "" ? null : obj[key];
      req[key] = obj[key] === "true" ? true : req[key];
      req[key] = obj[key] === "false" ? false : req[key];
    });
  }
  return req;
};

export const extractEconomicGroupsFromCompanies = (items) => {
  let economicGroups = {};
  let uniqueCompanies = {};
  items?.forEach((item) => {
    const economicGroupId = parseInt(item.economicGroupId);
    const economicGroupName = item?.economicGroup?.name;

    uniqueCompanies[item.id] = {
      name: item.socialName,
      economicGroupId,
    };

    economicGroups[economicGroupId] = {
      economicGroupName,
      companies: [],
    };
  });
  const companiesList = Object.keys(uniqueCompanies).map((key) => {
    return {
      id: parseInt(key),
      name: uniqueCompanies[key].name,
      economicGroupId: parseInt(uniqueCompanies[key].economicGroupId),
    };
  });

  const result = Object.keys(economicGroups).map((key) => {
    const item = economicGroups[key];
    const companies = companiesList.filter((company) => {
      return parseInt(company.economicGroupId) === parseInt(key);
    });
    return {
      id: parseInt(key),
      name: item.economicGroupName,
      companies,
    };
  });

  return result.reverse();
};

export const ajusteTimeZoneSaoPaulo = (date, timezone, format, addMinuts) => {
  let dataNew = moment(date).tz(timezone);
  moment.tz(timezone);
  let dataTimeZone = moment(dataNew);

  if (timezone && timezone === "America/Sao_Paulo") {
    timezone = "America/Bahia";
  }

  if (addMinuts) {
    dataTimeZone.add(addMinuts, "minutes");
  }

  return dataTimeZone.format(format);
};

export const getFirstItemFrom = (arr) => {
  if (arr && arr.length > 0) {
    return arr[0];
  }
  return {};
};

export const fixStrToNull = (filter) => {
  const obj = filter ? filter : this.getEmptyFilter();
  const req = {};
  Object.keys(obj).forEach((key) => {
    req[key] = obj[key] === "" ? null : obj[key];
    req[key] = obj[key] === "true" ? true : req[key];
    req[key] = obj[key] === "false" ? false : req[key];
  });
  return req;
};

export const handleSelectColor = (level) => {
  switch (level) {
    case "DEMO":
      return "blue_300";
    case "A0":
      return "green_100";
    case "A1":
      return "green_700";
    case "A2":
      return "green_400";
    case "B1":
      return "yellow_100";
    case "B2":
      return "yellow_700";
    case "C1":
      return "red_100";
    case "C2":
      return "red_500";
    case "DM":
      return "red_500";
    default:
      break;
  }
};

export const appVersion = "2.13.06";

export const isDevs = process.env.REACT_APP_LINK_API === "https://api-qas.lingofor.me" ? true : false;

export const getContentLinkWithSequentialScheduleId = (contentLink, sequentialScheduleId) => {
  if (!contentLink || !sequentialScheduleId) return contentLink;

  try {
    const contentUrl = new URL(contentLink);
    const collabUrl = new URL(process.env.REACT_APP_LINK_API_COLLAB);

    if (contentUrl.origin !== collabUrl.origin) return contentLink;
  } catch (error) {
    return contentLink;
  }

  const separator = contentLink.includes("?") ? "&" : "?";
  return `${contentLink}${separator}sequentialScheduleId=${encodeURIComponent(sequentialScheduleId)}`;
};

export const passwordValidator = (password = "", password2 = "") => {
  const lowerCase = new RegExp("(?=.*[a-z])");
  const numeric = new RegExp("(?=.*[0-9])");
  const specialCharacter = new RegExp('(?=.[\\!#$%@^&,-.?!="_+;:|{}¨<>~`()/])');
  const eightOrLonger = new RegExp("(?=.{6,})");
  const verificaContraBarra = (string) => /\\/g.test(string);
  //const upperCase = new RegExp("(?=.*[A-Z])");
  //const verificaEspaco = new RegExp("\\s");

  let messages = [
    { id: 1, message: "INVALID_PASS1", status: null },
    { id: 2, message: "INVALID_PASS2", status: null },
    { id: 3, message: "INVALID_PASS3", status: null },
    { id: 4, message: "INVALID_PASS4", status: null },
    { id: 5, message: "INVALID_PASS5", status: null },
    // { id: 6, message: ' Não utilizar espaços', status: null },
    // { id: 7, message: " Ter pelo menos 1 letra maiúscula", status: null },
  ];

  if (password !== "") {
    if (eightOrLonger.test(password)) {
      messages[0] = { id: 1, message: "INVALID_PASS1", status: true };
    }

    if (lowerCase.test(password)) {
      messages[1] = { id: 2, message: "INVALID_PASS2", status: true };
    }

    if (numeric.test(password)) {
      messages[2] = { id: 3, message: "INVALID_PASS3", status: true };
    }

    if (specialCharacter.test(password)) {
      messages[3] = { id: 4, message: "INVALID_PASS4", status: true };
    }

    if (verificaContraBarra(password)) {
      messages[3] = { id: 4, message: "INVALID_PASS4", status: true };
    }

    if (password === password2) {
      messages[4] = { id: 5, message: "INVALID_PASS5", status: true };
    }

    // if (!verificaEspaco.test(password)) {
    //   messages[5] = { id: 6, message: ' Não utilizar espaços', status: true };
    // }
    // if (upperCase.test(password)) {
    //   messages[6] = { id: 7, message: " Ter pelo menos 1 letra maiúscula", status: true };
    // }
  }
  return messages;
};

export const timeDisplayFormat = (value = "12") => (value === "12" ? "hh:mm A" : "HH:mm");
